import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import Avatar from "@mui/material/Avatar";
import logo from "./icon-logo_qm.svg";
import iconDisplay from "../../assets/images/icon-display.png";
import iconDisplayEmpty from "../../assets/images/icon-display-empty.png";
import deconnexion from "../../assets/images/deconnexion.png";
import "./navbar.css";
import "bootstrap/dist/css/bootstrap.css";
import { useDispatch } from "react-redux";
import { changeStyle } from "../../redux/actions/design";
import { useHistory } from "react-router-dom";
import { logout1 } from "../../redux/actions/auth";
import { libererAcces } from "../../redux/actions/calibrage";

const GloabalNavbar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const profile = JSON.parse(localStorage.getItem("profile"));
  let isHome = window.location.pathname === "/home";
  const currentPath = window.location.pathname;

  function displayAllSection() {
    dispatch(changeStyle(false, 0, "home"));
    if (currentPath === "/calibrage-en-cours") {
      let val = window.location.search;
      let pathChoice = val.substring(val.indexOf("=") + 1);
      dispatch(libererAcces(pathChoice));
    }
    history.push("/home");
  }
  const handleLogout = async (e) => {
    if (currentPath === "/calibrage-en-cours") {
      let val = window.location.search;
      let pathChoice = val.substring(val.indexOf("=") + 1);
      dispatch(libererAcces(pathChoice));
    }
    dispatch(logout1());
  };
  return (
    <Navbar
      className="container-navbar"
      style={{ backgroundColor: "white", height: "100px" }}
      expand="md"
    >
      <Container fluid>
        <Navbar.Brand href="#">
          <div className="globnav-logo">
            <p className="globnav-logo-title">
              Round <p className="globnav-logo_subtitle">QUALITY MONITORING</p>
            </p>
            <img style={{ paddingBottom: 30 }} src={logo} alt="Logo" />
          </div>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse
          id="navbarScroll"
          style={{ justifyContent: "space-between" }}
        >
          <Nav
            className="me-auto my-2 my-lg-0 sep"
            style={{ maxHeight: "100px" }}
            navbarScroll
          >
            <Nav.Link className="sepText" onClick={displayAllSection}>
              {isHome ? (
                <img
                  onClick={displayAllSection}
                  src={iconDisplay}
                  alt="Logo"
                  className="icon-display-all"
                />
              ) : (
                <img
                  onClick={displayAllSection}
                  src={iconDisplayEmpty}
                  alt="Logo"
                  className="icon-display-all"
                />
              )}
            </Nav.Link>
            <div className="verticalLine"></div>
          </Nav>
          <div className="globalnav-right-wrapper">
            <div className="rectangle2">
              <div className="img-profile">
                <Avatar
                  alt={user?.firstName}
                  sx={{ bgcolor: "#5800E2", width: "40px", height: "40px" }}
                  variant="rounded"
                >
                  {user?.firstName.charAt(0).toUpperCase() +
                    user?.lastName.charAt(0).toUpperCase()}
                </Avatar>
              </div>
              <p className="p1">
                {" "}
                {user?.firstName + " " + user?.lastName || ""}{" "}
              </p>
              <p className="p2"> {profile?.name || ""} </p>

              <div className="arrow">
                <i
                  className="fa fa-chevron-right "
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></i>

                <ul
                  className="dropdown-menu dropdown-menu-right dropdown-menu-navbar"
                  aria-labelledby="dropdownMenuLink"
                >
                  <li
                    className="log-out"
                    onClick={() => {
                      handleLogout();
                      localStorage.removeItem("access_token");
                      localStorage.removeItem("user_auth0");
                      localStorage.removeItem("user");
                      sessionStorage.clear();
                      history.go("/login");
                    }}
                  >
                    <img src={deconnexion} alt="Logo" height="30" /> Déconnexion
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default GloabalNavbar;
